import styled from "styled-components";

export const TtableContainer = styled.div`
  width: 71.2vw;
  // width:100%;
  padding: 0 10px;
  border-radius: 7px;
  margin: 0 auto;
  margin-left: 15px;

  .styledTable {
    font-size: 14px;
    font-weight: 500;
  }

  .tableHead {
    font-size: 14px;
    font-weight: 500;
  }

  .tableBody {
    font-size: 14px;
    font-weight: 400;
  }

  .tableBody tr {
    &:nth-child(odd) {
      // background-color: rgba(236, 241, 244, 0.8);
      background: #ccc;
    }
    &:nth-child(even) {
      background: #fff;
    }
  }
`;

export const TtableTitle = styled.div`
  background: #e6662c;
  color: white;
  padding: 10px;
  font-size: 14px;
  font-weight: 500;
`;
